import React from 'react';

function ContactSection() {
  const contacts = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      ),
      href: 'mailto:musawar.soomro25@gmail.com',
      label: 'musawar.soomro25@gmail.com'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
        </svg>
      ),
      href: 'https://www.linkedin.com/in/musawar/',
      label: 'LinkedIn',
      external: true
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      ),
      href: 'https://github.com/mazzyy',
      label: 'GitHub',
      external: true
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
        </svg>
      ),
      href: 'https://www.youtube.com/@Ideeaflux',
      label: 'YouTube @Ideeaflux',
      external: true
    }
  ];

  return (
    <div className="contact-section cyber-grid">
      <h2 className="section-title">Get in Touch</h2>
      <div className="contact-grid">
        <div className="contact-info">
          <h3>Let's Connect</h3>
          {contacts.map((contact, index) => (
            <a
              key={index}
              href={contact.href}
              target={contact.external ? '_blank' : undefined}
              rel={contact.external ? 'noopener noreferrer' : undefined}
              className="contact-link"
            >
              {contact.icon}
              <span>{contact.label}</span>
            </a>
          ))}
        </div>
        
        <div className="contact-terminal">
          <div className="contact-terminal-header">
            <div className="control-btn close"></div>
            <div className="control-btn minimize"></div>
            <div className="control-btn maximize"></div>
            <span style={{ marginLeft: '10px', color: 'var(--text-muted)' }}>zsh</span>
          </div>
          <div className="contact-terminal-body">
            <div className="terminal-line">
              <span className="terminal-prompt">➜</span>
              <span className="terminal-path"> ~/contact</span>
              <span className="terminal-command"> cat info.json</span>
            </div>
            <div className="terminal-line terminal-output">{'{'}</div>
            <div className="terminal-line terminal-output">
              &nbsp;&nbsp;<span className="string">"name"</span>: <span className="string">"Abdul Musawar Soomro"</span>,
            </div>
            <div className="terminal-line terminal-output">
              &nbsp;&nbsp;<span className="string">"email"</span>: <span className="string">"musawar.soomro25@gmail.com"</span>,
            </div>
            <div className="terminal-line terminal-output">
              &nbsp;&nbsp;<span className="string">"phone"</span>: <span className="string">"+49 152 17136471"</span>,
            </div>
            <div className="terminal-line terminal-output">
              &nbsp;&nbsp;<span className="string">"location"</span>: <span className="string">"Erlangen, Germany"</span>,
            </div>
            <div className="terminal-line terminal-output">
              &nbsp;&nbsp;<span className="string">"status"</span>: <span className="string">"Open to opportunities"</span>
            </div>
            <div className="terminal-line terminal-output">{'}'}</div>
            <div className="terminal-line" style={{ marginTop: '15px' }}>
              <span className="terminal-prompt">➜</span>
              <span className="terminal-path"> ~/contact</span>
              <span className="terminal-cursor"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactSection;
